export default __webpack_public_path__ + "e7e25bcf146ed4a95406aeff6d9e9090.svg";